import { FETCH_DYNAMIC_TARGETING_KEYS } from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";

const initialState = {
  isLoading: false,
  data: []
};

export const dcmDynamicTargetingKeys = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DYNAMIC_TARGETING_KEYS:
      switch (action.status) {
        case SUCCESS:
          return {
            isLoading: false,
            data: action.data 
          };
        case FAILURE:
          return {
            ...state,
            isLoading: false
          };
        case PENDING:
          return {
            ...state,
            isLoading: true
          };
        default:
          return state;
      }
    default:
      return state;
  }
};
